import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import MissionVision from './components/MissionVision';
import AgentOrdering from './components/AgentOrdering';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import BecomeAgent from './components/BecomeAgent';
import BackToTop from './components/BackToTop';

export default function Home() {
  const [isNavFixed, setIsNavFixed] = useState(false);

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsNavFixed(window.scrollY > 100);
    });
  }

  return (
    <div className="relative">
      <Navbar isFixed={isNavFixed} />
      <Hero />
      <About />
      <Services />
      <MissionVision />
      <Gallery />
      <BecomeAgent />
      <AgentOrdering />
      <BackToTop />
      <Contact />
      <Footer />
    </div>
  );
}